import React from 'react';
import { useField } from 'formik';

export default function SelectField(props) {
  const { label, labelClassName, placeholder, options, className, ...other } = props;
  const [field, meta, helpers] = useField(props);
  const isInvalid = meta.touched && meta.error;


  return (
    <div
      className={`flex flex-col pb-1`}
    >
      {label && <div className={`flex-auto text-13px font-extrabold tracking-none uppercase font-heading mb-1 ${labelClassName}`}>{label}</div>}
      <select
        className={`border h-12 px-4 w-full text-16px font-bold font-heading ${props?.className} ${isInvalid && 'border-[#ff0000]'} `}
        defaultValue={options[0]}
        {...field}
        {...other}
      >
        {options?.map((option) => (
          <option key={option} value={option}>{option}</option>
        ))}
      </select>
    </div>
  );
}
